import { FC } from 'react';
import { Box } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormData } from '../constants';
import dayjs from 'dayjs';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	errors: FieldErrors<FormData>;
	trigger: UseFormTrigger<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const TimeInputs: FC<Props> = ({ formWatch, control, errors, trigger, setValue }) => {
	return (
		<>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Box display="flex" justifyContent="space-between">
					<Controller
						name="startTime"
						control={control}
						render={({ field: { onChange, value }, formState: { errors } }) => (
							<TimePicker
								label="Start Time"
								value={value ? dayjs(value) : null}
								onChange={(value) => {
									onChange(value ? dayjs(value).format() : null);
									trigger('startTime');
								}}
								sx={{
									display: 'flex',
									justifyContent: 'flex-start',
									marginBottom: '1rem',
									width: '49%',
								}}
								slotProps={{
									textField: {
										fullWidth: true,
										error: !!errors.startTime,
										helperText: errors.startTime?.message,
										slotProps: {
											inputLabel: { shrink: true },
										},
									},
								}}
							/>
						)}
					/>
					<Controller
						name="endTime"
						control={control}
						render={({ field: { onChange, value }, formState: { errors } }) => (
							<TimePicker
								label="End Time"
								value={value ? dayjs(value) : null}
								onChange={(value) => {
									onChange(value ? dayjs(value).format() : null);
									trigger('endTime');
								}}
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									marginBottom: '1rem',
									width: '49%',
								}}
								slotProps={{
									textField: {
										fullWidth: true,
										error: !!errors.endTime,
										helperText: errors.endTime?.message,
										slotProps: {
											inputLabel: { shrink: true },
										},
									},
								}}
							/>
						)}
					/>
				</Box>
			</LocalizationProvider>
		</>
	);
};

export default TimeInputs;
